export default __webpack_public_path__ + "static/media/Unit_17_thumb.9fba6acf.jpg";